import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ParticipationComponent } from './participation/participation.component';
import { AuthGuard } from './_auth/auth-guard';
import {OfflineComponent} from './pm-controls/offline/offline.component';
import { SurveyDecodeComponent } from './survey-redirect/survey-decode/survey-decode.component';
import { PreviewComponent } from './Preview/preview/preview.component';
import { PrintResponseComponent } from './print-response/print-response.component';
import { SocialAuthenticationComponent } from './Social/social-authentication/social-authentication.component';
import { ShortKeyComponent } from './survey-redirect/short-key/short-key.component';
import { EditResponseComponent } from './edit-response/edit-response.component';

const routes: Routes = [
  { path: 'form', component: ParticipationComponent, canActivate: [AuthGuard]},
  { path: 'offline', component: OfflineComponent, canActivate: [AuthGuard]},
  { path: 'sd', component: SurveyDecodeComponent, canActivate: [AuthGuard]},
  { path: 'sk', component: ShortKeyComponent, canActivate: [AuthGuard]},
  { path: 'preview', component: PreviewComponent, canActivate: [AuthGuard]},
  { path: 'Print', component: PrintResponseComponent, canActivate: [AuthGuard]},
  { path: 'socialauth', component:SocialAuthenticationComponent,canActivate:[AuthGuard]},
  { path: 'editresponse', component:EditResponseComponent,canActivate:[AuthGuard]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
